import { Disclosure } from '@headlessui/react';
import Image from 'next/future/image';
import cn from 'classnames';
import { CategoryLandingPageKey } from '@lambda/apis/src/category/types';
import Section from '@/components/commons/Section';
import { FAQ } from '@/lib/collections/category/faq';
import ChevronDown from '@/public/icons/collection/chevron_down.svg';

const Faq = ({ handle }: { handle: CategoryLandingPageKey }) => {
  const content = FAQ[handle];

  if (content == null) return null;

  return (
    <Section className="pt-8 pb-5">
      <h2 className="flex items-center text-lg font-semibold md:text-xl">
        Frequently asked questions
      </h2>
      <div className="mt-3 text-sm">
        {content.map((faq) => {
          const parsedAnswer = faq.answer
            .replace(/<ul>/g, '<ul class="list-disc">')
            .replace(/<li>/g, '<li class="ml-3">');

          return (
            <Disclosure
              key={`${faq.question}`}
              as={'div'}
              className="w-full border-t border-[#DEE2E6] first:mt-0 first:border-t-0"
            >
              {({ open, close }) => (
                <div className="hover:underline">
                  <Disclosure.Button
                    className={cn(
                      'flex w-full items-center justify-between gap-3 text-left',
                      {
                        'py-3': !open,
                        'pt-3': open,
                      },
                    )}
                  >
                    <h4 className={cn({ 'font-bold': open })}>
                      {faq.question}
                    </h4>
                    <div className="relative h-3 w-3 shrink-0">
                      <Image
                        src={ChevronDown}
                        alt="Dropdown"
                        className={cn('h-full w-full object-contain', {
                          'rotate-180': open,
                        })}
                      />
                    </div>
                  </Disclosure.Button>
                  <Disclosure.Panel
                    as="button"
                    onClick={() => close()}
                    className="pb-3 text-left"
                  >
                    {parsedAnswer.split('\n').map((p) => (
                      <div
                        key={`${faq.question}_${p}`}
                        className="mt-3 text-sm text-gray-700/70 first:mt-0"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: p }}
                      />
                    ))}
                  </Disclosure.Panel>
                </div>
              )}
            </Disclosure>
          );
        })}
      </div>
    </Section>
  );
};

export default Faq;
